module.exports = __webpack_public_path__ + "images/motoguzzi_small70cad59d64ed32d7471deaae4b17e8c3.png";